import React, { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Link, useLocation, useRouteMatch } from 'react-router-dom';
import { Grid, IconButton, LinearProgress, Tooltip } from '@mui/material';
import ReadMoreIcon from '@mui/icons-material/ReadMore';

import { getDataList } from '../../../../helpers/getDataList';
import PageHeader from '../../includes/PageHeader';
import showMessage from '../../../../helpers/showMessage';
import { useSnackbar } from 'notistack';
import { Box } from '@mui/system';

export function ProgramTypeList() {
    const { pathname } = useLocation();

    const columns = [
        // {
        //     field: 'id',
        //     headerName: 'ID',
        //     //  width: 90
        //     flex: 1,
        // },
        {
            field: 'name',
            headerName: 'Тайлбар',
            // width: 500,
            flex: 1,
        },
        {
            field: 'active',
            headerName: 'Төлөв',
            // width: 90
            flex: 1,
            valueFormatter: ({ value }) => value ? 'идэвхтэй' : 'идэвхгүй',
        },
        {
            field: 'edit',
            headerName: 'Дэлгэрэнгүй',
            renderCell: (params) => {
                return (
                    <div>
                        <Link to={`${pathname}/${params.id}`}>
                            <Tooltip title="Засах">
                                <IconButton>
                                    <ReadMoreIcon />
                                </IconButton>
                            </Tooltip>
                        </Link>
                    </div>
                );
            },
            // width: 115,
            flex: 1,
        },
    ];

    const [isLoading, setIsLoading] = useState(true);
    const [programTypeList, setProgramTypeList] = useState([]);
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        let isActive = true;

        getDataList('program-type/all')
            .then((response) => {
                if (isActive) {
                    setProgramTypeList(response.data?.data);
                }
                setIsLoading(false);
            })
            .catch((error) => {
                const message = error.response?.data?.message
                    ? error.response.data.message
                    : error.message;
                showMessage(message, enqueueSnackbar, 'error');
            });

        return () => {
            isActive = false;
        };
    }, []);

    const { path } = useRouteMatch();
const localizedTextsMap = {
  columnMenuUnsort: "Ангилаагүй",
  columnMenuSortAsc: "Өсөхөөр эрэмблэх",
  columnMenuSortDesc: "Буурахаар эрэмблэх",
  columnMenuFilter: "Хайх",
  columnMenuHideColumn: "Нуух",
  columnMenuShowColumns: "Багана харах"
};
    return (
        <Grid
            container
            justifyContent="center"
            style={{ height: 630, width: '100%' }}
        >
            <PageHeader
                pageName="Хөтөлбөрийн төрөл"
                addNewLink={path + '/create'}
            />
            {isLoading ? (
                <Box sx={{ width: '100%' }}>
                    <LinearProgress />
                </Box>
            ) : (
                <DataGrid
                    rows={programTypeList}
                    columns={columns}
                    pageSize={100}
                    rowsPerPageOptions={[10, 20, 30, 40, 50]}
                    checkboxSelection={false}
                        disableSelectionOnClick
                        localeText={localizedTextsMap}
                />
            )}
        </Grid>
    );
}
